// extracted by mini-css-extract-plugin
export default {"icon":"DetailButton_icon__jk+61","trigger":"DetailButton_trigger__lrSdV","activeTrigger":"DetailButton_activeTrigger__k2Wx-","link":"DetailButton_link__wMzYf"};